import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Setup VisualViewport-driven CSS variables for robust mobile sizing
if (typeof window !== 'undefined' && !window.__vvhListeners) {
  const setVvUnits = () => {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    const width = vv ? vv.width : window.innerWidth;
    document.documentElement.style.setProperty('--vvh', `${Math.round(height)}px`);
    document.documentElement.style.setProperty('--vvw', `${Math.round(width)}px`);
  };
  setVvUnits();
  window.addEventListener('resize', setVvUnits, { passive: true });
  window.addEventListener('orientationchange', setVvUnits, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVvUnits, { passive: true });
    // Removed scroll listener - it was causing performance issues during scrolling
  }
  window.__vvhListeners = true;
}

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);